import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, ButtonGroup } from 'react-bootstrap'

import NavigationBar from '../components/NavigationBar'
import AdminNavBar from '../components/Admin/AdminNavBar'
import Footer from '../components/Footer/Footer'
import { useAuth, AuthContext } from '../contexts/AuthContext'
import { LOGIN_PATH } from '../config/routes'
import config from '../config/config'
import { setFlashMessage, useWebsite } from '../contexts/WebsiteContext'
import ContactThumbnail from '../components/Admin/ContactThumbnail'

const ManageContacts = () => {
  const { token } = useAuth()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { isAdmin, logout } = useContext(AuthContext)
  const [contacts, setContacts] = useState([])
  const [filterStatus, setFilterStatus] = useState('NEW')

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}contact`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            status: filterStatus,
          },
        })
        setContacts(response.data)
      } catch (error) {
        //console.error('Error webservice call:', error);

        if (error.response && error.response.status === 401) {
          logout()
          navigate(LOGIN_PATH)
        } else if (error.response) {
          setFlashMessage(t('ERROR_MESSAGE'), 'error')
        }
      }
    }

    fetchContacts()
  }, [isAdmin, logout, navigate, token, filterStatus, t])

  const handleFilterChange = (status) => {
    setFilterStatus(status)
  }

  const handleStatusChange = (contactId, newStatus) => {
    setContacts((prevContacts) =>
      prevContacts.map((contact) =>
        contact.id === contactId ? { ...contact, status: newStatus } : contact,
      ),
    )
  }

  return (
    <div>
      <NavigationBar />
      <AdminNavBar />
      <h1>{t('MANAGE_CONTACTS_TITLE')}</h1>
      <ButtonGroup
        className="mb-2"
        style={{ textAlign: 'center', marginLeft: '10px' }}
      >
        <Button
          variant={filterStatus === 'NEW' ? 'primary' : 'secondary'}
          onClick={() => handleFilterChange('NEW')}
        >
          {t('NEW')}
        </Button>
        <Button
          variant={filterStatus === 'PROCESSED' ? 'primary' : 'secondary'}
          onClick={() => handleFilterChange('PROCESSED')}
        >
          {t('PROCESSED')}
        </Button>
        <Button
          variant={filterStatus === 'ARCHIVED' ? 'primary' : 'secondary'}
          onClick={() => handleFilterChange('ARCHIVED')}
        >
          {t('ARCHIVED')}
        </Button>
      </ButtonGroup>
      <div style={{ marginBottom: '20px' }}>
        {contacts.length > 0 ? (
          contacts
            .filter((contact) => contact.status === filterStatus)
            .map((contact) => (
              <ContactThumbnail
                key={contact.id}
                contact={contact}
                onStatusChange={handleStatusChange}
              />
            ))
        ) : (
          <p
            className="green-frame"
            style={{ margin: '5px', paddingBottom: '10px' }}
          >
            {t('NO_CONTACTS')}
          </p>
        )}
      </div>
      <img
        className="img-fluid"
        src="/images/photos/95cc8f97-0f60-4275-a019-d2f30f928658.jpg"
        alt="La carrière de marbre de Sost"
      />
      <Footer />
    </div>
  )
}

export default ManageContacts
